import React from "react";
import styled from "styled-components";

import { images } from "assets/img/common/common";
import { giftcard_images } from "assets/img/giftcard/common";

const Box = styled.div`
    display: flex;
    align-items: center;
    padding: 6px;

    border-radius: 12px;
    background: rgb(0, 29, 75);
    background: linear-gradient(
        61deg,
        rgba(0, 29, 75, 1) 0%,
        rgba(0, 49, 122, 1) 30%,
        rgba(0, 64, 164, 1) 52%,
        rgba(0, 49, 122, 1) 70%,
        rgba(0, 29, 75, 1) 100%
    );

    > div:first-child {
        display: flex;
        align-items: center;
        gap: 50px;
        background: rgba(0, 0, 0, 0.5);
        padding: 20px 24px;
        border-radius: 12px;
    }

    h2 {
        color: #fff;
    }

    p {
        font-size: 20px;
        color: rgba(255, 238, 247, 0.6);
    }

    img {
        max-width: 200px;
        border-radius: 12px;
        border: 5px solid hsla(0, 0%, 100%, 0.1);
        box-shadow: 0 0 30px rgb(0 0 0 / 50%);
    }

    @media screen and (max-width: 768px) {
        text-align: center;

        > div:first-child {
            flex-direction: column;
            justify-content: center;

            padding: 20px 10px;
        }

        h2 {
            font-size: 24px;
        }

        p {
            font-size: 18px;
        }

        img {
            box-shadow:none;
            border:none;
        }
    }
`;

const DownloadBox = () => {
    return (
        <Box id="download" className="show-desktop">
            <div>
                <div>
                    <h2 className="show-desktop">
                        Escanea el código QR para continuar desde la app de
                        Buenbit
                    </h2>
                    <p>
                        Adémas comprá y vendé criptomonedas, invertilas para
                        recibir ganancias diarias y ganale a la inflación.
                    </p>
                </div>
                <img src={images.qrStores} className="show-desktop" />
            </div>
        </Box>
    );
};

export default DownloadBox;
